module.exports = "<div *ngIf=\"toast?.message\" class=\"toast\" [ngClass]=\"'toast-'+toast?.type\" [class.fade-in-out]=\"activeMessage\">\n  {{toast?.message}}\n  <span (click)=\"hide()\">×</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/toast/toast.component.html
// module id = ./src/app/common/toast/toast.component.html
// module chunks = main